import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './components/home/home.component';
// Parité V1 : ChartModule ('primeng/chart') remplacé par le wrapper local UiChartModule —
// le ChartModule de PrimeNG 21 exige Chart.js 4 alors que le rendu épinglé utilise
// Chart.js 2.9.4 chargé en script global (window.Chart). Même sélecteur <p-chart>, même API v8.
// NB : aucun <p-chart> n'est utilisé dans le template de HomeComponent (vérifié) ;
// l'import est conservé pour parité de structure avec le module V1.
import { UiChartModule } from '@shared/vendored/ui-chart';
// Parité V1 : import 'chartjs-plugin-datalabels' (side-effect) NON conservé — le paquet
// n'est pas installé dans ClientAppV2 (absent de package.json/node_modules) et aucun graphe
// n'est rendu par HomeComponent. À réactiver si le paquet est ajouté (npm i chartjs-plugin-datalabels@0.7.0).
// import 'chartjs-plugin-datalabels';
import { AppLoadingDirectiveModule } from '@modules/common/loading/loading.directive';
import { RouterModule } from '@angular/router';
// Parité V1 : NgApexchartsModule ('ng-apexcharts') supprimé — paquet non installé en V2
// (apexcharts est chargé en script global) et aucun <apx-chart> n'est utilisé dans les
// templates de home (vérifié). Aucun impact comportemental.
import { AppCommonModule } from '@modules/common/app-common.module';

@NgModule({
  imports: [
    CommonModule,
    UiChartModule,
    AppLoadingDirectiveModule,
    RouterModule,
    AppCommonModule
  ],
  declarations: [
    HomeComponent
  ]
  // Parité V1 : entryComponents supprimé (retiré d'Angular depuis Ivy) — la liste V1 était vide.
})
export class HomeModule { }
